import { useMemo } from 'react';

import { useAutoplayHiddenFlag } from '../../../store/compositeSelectors/useAutoplayHiddenFlag';
import { useSubtitlesSlice } from '../../../store/slices/subtitles/selectors';

export const useHelpChaptersToHideConnected = (): string[] => {
  const hideSubtitles = !useSubtitlesSlice.isAvailable();
  const hideAutoplay = useAutoplayHiddenFlag();

  return useMemo(() => {
    const chaptersToHide = [];
    if (hideSubtitles) {
      chaptersToHide.push('subtitles');
    }
    if (hideAutoplay) {
      chaptersToHide.push('autoplay');
      chaptersToHide.push('autobet');
    }
    return chaptersToHide;
  }, [hideSubtitles, hideAutoplay]);
};
